import { Container } from "@mui/material";
import Header from "./header";
import Table from "components/Table";
import { installmentsTable } from "./table";

export default function Installments() {
  return (
    <Container maxWidth="lg">
      <div className="my-10">
        <Header />
      </div>
      <div className="bg-white rounded-md">
        <Table tabs={installmentsTable}  />
      </div>
    </Container>
  );
}
